import React from 'react';
import { Button } from 'reactstrap';
import { useFieldArray } from 'react-hook-form';

export default function({ form, arrayName, accept }) {
  const { control, register } = form;
  const array = arrayName;
  const files = useFieldArray({ control, name: `${array}` });

  return (
    <div>
      {files.fields.map((item, index) => (
        <div key={item.id}>
          <label className="d-inline-flex align-items-center">
            <input
              defaultValue={item.file}
              {...register(`files.${index}.file`)}
              type="file"
              accept={accept ? accept : '*'}
              className="form-control input_file_hidebutton"
            />
            <span className="mr-2 btn btn-secondary col-auto">Choose File</span>
          </label>

          {files.fields.length > 1 && (
            <Button type="button" onClick={() => files.remove(index)}>
              Delete
            </Button>
          )}

          {index + 1 === files.fields.length && (
            <div className="d-inline-block align-self-end ml-2">
              <Button
                onClick={() => files.append({})}
                type="button"
                className="mr-2 align-self-bottom"
              >
                Add More Files
              </Button>
            </div>
          )}
        </div>
      ))}

      {files.fields.length === 0 && (
        <div className="d-inline-block align-self-end ml-2">
          <Button onClick={() => files.append({})} type="button" className="mr-2 align-self-bottom">
            Add Files
          </Button>
        </div>
      )}
    </div>
  );
}
